import './App.css';
import './Responsive.css';
import {lazy, Suspense} from "react";
import {Navigate, Route, Routes} from "react-router-dom";
import PageMeta from "./components/PageMeta";
import ScrollToTop from "./components/ScrollToTop";

// Each page loads as its own chunk, so visitors only download the pages they open (not every blog post and
// the admin dashboards).
const Home = lazy(() => import("./components/Home"));
const About = lazy(() => import("./components/About"));
const Services = lazy(() => import("./components/Services"));
const Pricing = lazy(() => import("./components/Pricing"));
const Contact = lazy(() => import("./components/Contact"));
const TaskAutomation = lazy(() => import("./components/sub-service/TaskAutomation"));
const CommunicationAutomation = lazy(() => import("./components/sub-service/CommunicationAutomation"));
const FinancialAutomation = lazy(() => import("./components/sub-service/Financial Automation"));
const WorkflowAutomation = lazy(() => import("./components/sub-service/WorkflowAutomation"));
const CustomAutomation = lazy(() => import("./components/sub-service/CustomAutomation"));
const AIIntegrations = lazy(() => import("./components/sub-service/AIIntegrations"));
const CustomApplications = lazy(() => import("./components/sub-service/CustomApplications"));
const Privacy = lazy(() => import("./components/Privacy"));
const Terms = lazy(() => import("./components/Terms"));
const Blogs = lazy(() => import("./components/Blogs"));
const LogIn = lazy(() => import("./components/LogIn"));
const SignUp = lazy(() => import("./components/SignUp"));
const AdminDashboard = lazy(() => import("./components/AdminDashboard"));
const ForgotPassword = lazy(() => import("./components/ForgotPassword"));
const ResetPassword = lazy(() => import("./components/ResetPassword"));
const ChangePassword = lazy(() => import("./components/ChangePassword"));
const AdminSubscription = lazy(() => import("./components/AdminSubscription"));
const AdminUser = lazy(() => import("./components/AdminUser"));
const AdminPaymentLink = lazy(() => import("./components/AdminPaymentLink"));
const AdminCharge = lazy(() => import("./components/AdminCharge"));
const UserDashboard = lazy(() => import("./components/UserDashboard"));
const UserCharge = lazy(() => import("./components/UserCharge"));
const UserSubscription = lazy(() => import("./components/UserSubscription"));
const UserPaymentLink = lazy(() => import("./components/UserPaymentLink"));
const Blog1 = lazy(() => import("./components/blog/Blog1"));
const Blog2 = lazy(() => import("./components/blog/Blog2"));
const Blog3 = lazy(() => import("./components/blog/Blog3"));
const Blog4 = lazy(() => import("./components/blog/Blog4"));
const Blog5 = lazy(() => import("./components/blog/Blog5"));
const Blog6 = lazy(() => import("./components/blog/Blog6"));
const Blog7 = lazy(() => import("./components/blog/Blog7"));
const Blog8 = lazy(() => import("./components/blog/Blog8"));
const Blog9 = lazy(() => import("./components/blog/Blog9"));
const Blog10 = lazy(() => import("./components/blog/Blog10"));
const Blog11 = lazy(() => import("./components/blog/Blog11"));
const Blog12 = lazy(() => import("./components/blog/Blog12"));
const Blog13 = lazy(() => import("./components/blog/Blog13"));
const Blog14 = lazy(() => import("./components/blog/Blog14"));
const Blog15 = lazy(() => import("./components/blog/Blog15"));
const Blog16 = lazy(() => import("./components/blog/Blog16"));
const Blog17 = lazy(() => import("./components/blog/Blog17"));
const Blog18 = lazy(() => import("./components/blog/Blog18"));
const Blog19 = lazy(() => import("./components/blog/Blog19"));
const Blog20 = lazy(() => import("./components/blog/Blog20"));
const Blog21 = lazy(() => import("./components/blog/Blog21"));
const Blog22 = lazy(() => import("./components/blog/Blog22"));
const Blog23 = lazy(() => import("./components/blog/Blog23"));

function App() {
    return (
        <>
            <PageMeta/>
            <ScrollToTop/>
            <Suspense fallback={null}>
                <Routes>
                    <Route path={"/"} element={<Home/>}/>
                    <Route path={"/about/*"} element={<About/>}/>
                    <Route path={"/services/*"} element={<Services/>}/>
                    <Route path={"/services/task/*"} element={<TaskAutomation/>}/>
                    <Route path={"/services/communication/*"} element={<CommunicationAutomation/>}/>
                    <Route path={"/services/financial/*"} element={<FinancialAutomation/>}/>
                    <Route path={"/services/workflow/*"} element={<WorkflowAutomation/>}/>
                    <Route path={"/services/custom/*"} element={<CustomAutomation/>}/>
                    <Route path={"/services/ai/*"} element={<AIIntegrations/>}/>
                    <Route path={"/services/apps/*"} element={<CustomApplications/>}/>
                    <Route path={"/pricing/*"} element={<Pricing/>}/>
                    <Route path={"/contact/*"} element={<Contact/>}/>
                    <Route path={"/privacy/*"} element={<Privacy/>}/>
                    <Route path={"/terms/*"} element={<Terms/>}/>
                    <Route path={"/blogs/*"} element={<Blogs/>}/>
                    <Route path={"/blogs/1/*"} element={<Blog1/>}/>
                    <Route path={"/blogs/2/*"} element={<Blog2/>}/>
                    <Route path={"/blogs/3/*"} element={<Blog3/>}/>
                    <Route path={"/blogs/4/*"} element={<Blog4/>}/>
                    <Route path={"/blogs/5/*"} element={<Blog5/>}/>
                    <Route path={"/blogs/6/*"} element={<Blog6/>}/>
                    <Route path={"/blogs/7/*"} element={<Blog7/>}/>
                    <Route path={"/blogs/8/*"} element={<Blog8/>}/>
                    <Route path={"/blogs/9/*"} element={<Blog9/>}/>
                    <Route path={"/blogs/10/*"} element={<Blog10/>}/>
                    <Route path={"/blogs/11/*"} element={<Blog11/>}/>
                    <Route path={"/blogs/12/*"} element={<Blog12/>}/>
                    <Route path={"/blogs/13/*"} element={<Blog13/>}/>
                    <Route path={"/blogs/14/*"} element={<Blog14/>}/>
                    <Route path={"/blogs/15/*"} element={<Blog15/>}/>
                    <Route path={"/blogs/16/*"} element={<Blog16/>}/>
                    <Route path={"/blogs/17/*"} element={<Blog17/>}/>
                    <Route path={"/blogs/18/*"} element={<Blog18/>}/>
                    <Route path={"/blogs/19/*"} element={<Blog19/>}/>
                    <Route path={"/blogs/20/*"} element={<Blog20/>}/>
                    <Route path={"/blogs/21/*"} element={<Blog21/>}/>
                    <Route path={"/blogs/22/*"} element={<Blog22/>}/>
                    <Route path={"/blogs/23/*"} element={<Blog23/>}/>
                    <Route path={"/login/*"} element={<LogIn/>}></Route>
                    <Route path={"/signup/*"} element={<SignUp/>}></Route>
                    <Route path={"/admin/*"} element={<AdminDashboard/>}></Route>
                    <Route path={"/admin/subscription/*"} element={<AdminSubscription/>}></Route>
                    <Route path={"/admin/payment-link/*"} element={<AdminPaymentLink/>}></Route>
                    <Route path={"/admin/charge/*"} element={<AdminCharge/>}></Route>
                    <Route path={"/admin/user/*"} element={<AdminUser/>}></Route>
                    <Route path={"/dashboard/charge/*"} element={<UserCharge/>}></Route>
                    <Route path={"/dashboard/subscription/*"} element={<UserSubscription/>}></Route>
                    <Route path={"/dashboard/payment-link/*"} element={<UserPaymentLink/>}></Route>
                    <Route path={"/account/*"} element={<UserDashboard/>}></Route>
                    <Route path={"/forgot-password/*"} element={<ForgotPassword/>}></Route>
                    <Route path={"/reset-password/*"} element={<ResetPassword/>}></Route>
                    <Route path={"/change-password/*"} element={<ChangePassword/>}></Route>

                    {/*<Route path={"/change-password"} element={<ChangePassword/>}></Route>*/}
                    {/*<Route path={"/forgot-password"} element={<ForgotPassword/>}></Route>*/}
                    {/*<Route path={"/reset-password"} element={<ResetPassword/>}></Route>*/}
                    <Route path={'*'} element={<Navigate to="/"/>}/>
                </Routes>
            </Suspense>
        </>
    );
}

export default App;
